export const isServer = typeof window === 'undefined';
export const isNavigator = typeof navigator !== 'undefined';

const getUserAgent = (userAgent?: string): string => {
  if (userAgent !== undefined) return userAgent;
  if (isServer || !isNavigator) return '';

  return navigator.userAgent || navigator.vendor || '';
};

export const isIOSDevice = !isServer && /iPad|iPhone/.test(getUserAgent());

export const isMac = !isServer && /Macintosh/.test(getUserAgent());

export const isBrowser = !isServer && typeof document !== 'undefined';

export const isTouchDevice =
  !isServer && window.matchMedia('(pointer: coarse)').matches;

// Utility to detect if the user is on a mobile device
export const isMobileDevice = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const IN_APP_BROWSER_PATTERN =
  /\b(FBAN|FBAV|FB_IAB|FBIOS|FB4A|Instagram|Line|Twitter|TwitterAndroid|TikTok|musical_ly|BytedanceWebview|Messenger|LinkedInApp)\b/i;

// Utility to detect Android WebView
export const isAndroidWebView = (userAgent?: string) => {
  const ua = getUserAgent(userAgent);
  const isWebView =
    /; wv\)/i.test(ua) ||
    (/\bVersion\/\d+\.\d+\b/i.test(ua) && !/Chrome\/\d+/i.test(ua));

  return /Android/i.test(ua) && isWebView;
};

// Utility to detect iOS WebView
export const isIOSWebView = (userAgent?: string) => {
  const ua = getUserAgent(userAgent);

  return (
    /iP(hone|od|ad)/i.test(ua) && /AppleWebKit/i.test(ua) && !/Safari/i.test(ua)
  );
};

// Utility to detect in-app browsers (Facebook, LINE, Instagram, etc.)
export const isInAppBrowser = (userAgent?: string) => {
  const ua = getUserAgent(userAgent);
  if (!ua) return false;

  return (
    IN_APP_BROWSER_PATTERN.test(ua) || isAndroidWebView(ua) || isIOSWebView(ua)
  );
};
